var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"utitle",attrs:{"title":_vm.getTitleItemTooltip(),"to":_vm.getClientForumRoute(_vm.titleItem.game)}},[_c('div',{staticClass:"gameName"},[_vm._v(_vm._s(_vm.titleItem.game.name))]),_c('div',{staticClass:"sepline"}),_c('div',{staticClass:"itemName"},[_vm._v(_vm._s(_vm.titleItem.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }